import React from "react"
import { BblImageColumnBlockPreview } from "./queries"
import { makeStyles } from "@material-ui/styles"
import { buildBlocks } from "../../../services/builder"
import styles from "./styles"

const useStyles = makeStyles(theme => styles(theme))

export const BblImageColumnBlock = ({
  attributes,
  innerBlocks,
  parentAttributes,
  pageContext,
}) => {
  const blocks = buildBlocks(innerBlocks, parentAttributes, pageContext)
  const classes = useStyles()

  const { className } = attributes

  return (
    <div className={`image-column ${className} ${classes.imageColumn} `}>
      {blocks.map(block => {
        return block
      })}
    </div>
  )
}

export { BblImageColumnBlockPreview }
